import { render, staticRenderFns } from "./businessAssistant.vue?vue&type=template&id=d4d7139e&scoped=true&"
import script from "./businessAssistant.vue?vue&type=script&lang=js&"
export * from "./businessAssistant.vue?vue&type=script&lang=js&"
import style0 from "./businessAssistant.vue?vue&type=style&index=0&id=d4d7139e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d7139e",
  null
  
)

export default component.exports